import { useStaticQuery, graphql } from "gatsby";

export interface DeploymentDetails {
  url: string;
  makecodeVersion: string;
}

export const useDeploymentDetails = () => {
  const { site } = useStaticQuery(
    graphql`
      query DeploymentMetadataQuery {
        site {
          siteMetadata {
            siteUrl
            makecodeVersion
          }
        }
      }
    `
  );
  const details: DeploymentDetails = {
    url: site.siteMetadata.siteUrl,
    makecodeVersion: site.siteMetadata.makecodeVersion
  };
  return details;
};
